import DownloadIcon from '@mui/icons-material/Download';
import { Box, Tooltip } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import { Item, WsButton } from 'wisestep-base';

import { downloadSearchAttachment, IConfiguredAccountsDTO } from '../../helper';
import { ImapSearchResponse } from '../hooks/useSearch';

export const SearchEmailAttachments = (
  emailContent: ImapSearchResponse,
  configuredAccount: IConfiguredAccountsDTO
) => {
  return emailContent &&
    emailContent.attachments &&
    !isEmpty(emailContent?.attachments) &&
    configuredAccount
    ? emailContent.attachments.map((attachment, index) => (
        <Box key={index} display="flex" flexDirection="row" position="relative">
          <Item>
            <Tooltip title="Download">
              <Box textAlign="center">
                <WsButton
                  startIcon={<DownloadIcon sx={{ color: "text.primary'" }} />}
                  variant="contained"
                  onClick={() => {
                    downloadSearchAttachment(
                      configuredAccount.recruiterEmail,
                      attachment.fileLocation
                    );
                  }}
                >
                  {attachment.fileName}
                </WsButton>
              </Box>
            </Tooltip>
          </Item>
        </Box>
      ))
    : [<></>];
};
